<template>
  <ClientOnly>
  <vue-awesome-paginate
    :total-items="lastPage"
    :items-per-page="1"
    :max-pages-shown="5"
    v-model="currentPage"
  />
  </ClientOnly>

</template>

<script setup>
import { VueAwesomePaginate } from 'vue-awesome-paginate'
const route = useRoute()
const router = useRouter()

const props = defineProps({
  lastPage: { type: Number, required: true },
})

const currentPage = ref(Number(route.params.page ?? 1) || 1)

// klik/izbor strane -> promeni rutu
watch(currentPage, (p) => {
  const page = Math.max(1, Math.min(Number(p) || 1, props.lastPage))

  if (Number(route.params.page ?? 1) === page) return

  router.push({
    name: route.name,
    params: { ...route.params, page },
    query: route.query,
  })
})

// back/forward / direktan link
watch(
  () => route.params.page,
  (p) => {
    currentPage.value = Number(p ?? 1) || 1
  }
)
</script>
